import { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { getContentViewDate } from 'pages/Cms/View/utils'
import { historyModificationTypes } from 'types'
import { getAvatarDataFromHistory } from 'utils/avatar'
import type { CmsHistoryContentProps } from './types'

const useCmsContentHistory = ({ history }: CmsHistoryContentProps) => {
  const { t, locale } = useFavurTranslation()
  const avatar = getAvatarDataFromHistory(history)
  const timeAt = getContentViewDate({ locale, date: history.insertedAt })

  const translations = useMemo(() => {
    switch (history.modificationType) {
      case historyModificationTypes.createContent:
        return { title: 'page.cms.content.createdBy', date: 'page.cms.content.createdAt' }

      case historyModificationTypes.updateContent:
        return { title: 'page.cms.content.updatedBy', date: 'page.cms.content.updatedAt' }

      default:
        return { title: '', date: '' }
    }
  }, [history.modificationType])

  return { t, locale, avatar, timeAt, translations, history }
}

export default useCmsContentHistory
